import { useCallback, useMemo, useState } from "react";
import Table from "@/common/components/Table";
import { Pagination } from "@/common/components/pagination";
import useQuery from "@/hooks/useQuery";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import { useNavigate } from "react-router-dom";
import { KeyValueObj } from "@/common/types";
import {
  downloadCSVTemplate,
  getSecretariatFacilityTableData,
  newFundRequestForm,
  secretariatFacilityTableHeaders,
  secretariatFacilityTableKeys,
} from "../data";
import { Button } from "@/common/components/button";
import { LightBackdrop } from "@/common/components/lightBackdrop";
import { PopupWrapper } from "@/common/elements/containers";
import { usePositioning } from "@/hooks/usePositioning";
import { Modal } from "@/common/components/modal";
import Form from "@/common/components/form/Form";
import { SecretaryFinancialsWrapper } from "../styles";

const SecreataryFinancials = () => {
  const [secretariatFacilityPerpage, setSecretariatFacilityPerpage] =
    useState(10);
  const [currentRow, setCurrentRow] = useState<KeyValueObj>({});
  const [showRequestMenu, setShowRequestMenu] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const [setPosition, position1] = usePositioning();
  const [newRequestModal, setNewRequestModal] = useState<boolean>(false);

  const {
    data: secretariatFacilityData,
    meta: secretariatFacilityMeta,
    loading: secretariatFacilityLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${secretariatFacilityPerpage}&page=${secretariatFacilityPerpage}`
  );

  function onMenuClick(e: any) {
    setPosition(e);
    setShowRequestMenu(!showRequestMenu);
  }

  const handleDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showDropdown;
      const newRow = willShow ? row : {};

      setCurrentRow(newRow);
      setShowDropdown(willShow);
    },
    [showDropdown]
  );

  const handleFacilityView = useCallback(() => {
    // update active row ID
    navigate("/dashboard/state-sec/drf-facility/drf/1");
  }, []);

  const handleAllocation = () => {
    setNewRequestModal(true);
    setShowRequestMenu(false);
  };

  const handleUpload = () => {
    alert("comming soon during implementation");
  };

  const allocationsAction: {
    title: string;
    value?: string;
    action: () => void;
  }[] = [
    {
      title: "Single Allocation",
      value: "single",
      action: () => handleAllocation(),
    },
    {
      title: "Batch(upload CSV)",
      value: "batch",
      action: () => handleUpload(),
    },
  ];

  const secretariatFacilityDropdowns = useMemo(
    () =>
      currentRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleFacilityView }]
        : [{ label: "View", action: handleFacilityView }],
    [handleFacilityView, currentRow]
  );

  const handleNewRequestSubmit = () => {
    alert("submission requested");
  };

  return (
    <SecretaryFinancialsWrapper>
      <div className="button-section">
        {/* <div className="button-wrapper">
        </div> */}
        <Button onClick={onMenuClick}>New Fund Request</Button>
        <Button secondary onClick={downloadCSVTemplate}>
          Download CSV
        </Button>
        {showRequestMenu && (
          <LightBackdrop onBackdropClick={() => setShowRequestMenu(false)}>
            <PopupWrapper position={position1}>
              <div className="allocation">
                {allocationsAction?.map((allocation) => {
                  return (
                    <Button
                      width="150px"
                      secondary
                      onClick={allocation?.action}
                      bg="white"
                    >
                      {allocation?.title}
                    </Button>
                  );
                })}
              </div>
            </PopupWrapper>
          </LightBackdrop>
        )}
      </div>
      <div className="table-wrapper">
        <Table
          tableHeaders={secretariatFacilityTableHeaders}
          tableKeys={secretariatFacilityTableKeys}
          tableData={getSecretariatFacilityTableData(secretariatFacilityData)}
          tableTitle="DRF Enabled Facilities"
          loading={secretariatFacilityLoading}
          handleDropDownClicked={handleDropdownClick}
          showDropDown={showDropdown}
          dropDownOptions={secretariatFacilityDropdowns}
          spaced
          rowLineColor="light"
        />
        <Pagination
          pageCount={secretariatFacilityMeta?.total_pages}
          onNextPage={(event: any) =>
            setSecretariatFacilityPerpage(event.selected)
          }
          onPerPageChange={(event: any) =>
            setSecretariatFacilityPerpage(event?.target?.value)
          }
        />
      </div>
      <Modal
        title={`Single Allocation`}
        isOpen={newRequestModal}
        close={() => setNewRequestModal(false)}
      >
        <div className="modal">
          <Form
            formInputs={newFundRequestForm}
            processInputs={handleNewRequestSubmit}
          />
        </div>
      </Modal>
    </SecretaryFinancialsWrapper>
  );
};

export default SecreataryFinancials;
